import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

export function useFinancialCategories(basePath) {
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCategories = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get(basePath, { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => setCategories(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [basePath, navigate]);

  useEffect(() => {
    fetchCategories();
  }, [fetchCategories]);

  return { categories, isLoading, error, refetch: fetchCategories };
}
